import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";
import Button from "../../../../Button";
import Header from "../../../../Header";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";
import Input from "../../../../Input";

function View({ contact, onSubmit, onClose, locked }) {
  const { t } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      ...contact,
      acceptContact: get(contact, "acceptContact") || false,
      acceptDigital: true,
    },
    onSubmit,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
    ),
  });
  return (
    <div className="amellis__help--modal">
      <Header
        small
        title="Renseignez vos informations afin qu'un conseiller puisse prendre contact avec vous"
        highlight="conseiller puisse prendre contact avec vous"
      />
      <div className="grid--1">
        <div className="grid--1">
          <div className="grid--2">
            <Input
              placeholder={"ex : Doe"}
              label={"Nom"}
              {...bindInputProps({
                name: "user.lastname",
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue("user.lastname", value);
                setFieldValue(
                  "showTelecoms",
                  values.showTelecoms ||
                    !!(value && get(values, "user.firstname"))
                );
              }}
            />
            <Input
              placeholder={"ex : John"}
              label={"Prénom"}
              {...bindInputProps({
                name: "user.firstname",
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue("user.firstname", value);
                setFieldValue(
                  "showTelecoms",
                  values.showTelecoms ||
                    !!(value && get(values, "user.lastname"))
                );
              }}
            />
          </div>
          <div className="grid--2">
            <Input
              placeholder={"ex : 0610203040"}
              label={"N° de téléphone"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                  value
                );
                setFieldValue(
                  "showAccept",
                  values.showAccept ||
                    !!(
                      value &&
                      get(
                        values,
                        `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`
                      )
                    )
                );
              }}
            />
            <Input
              placeholder={"ex : johndoe@mail.com"}
              label={"Email"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                  value
                );
                setFieldValue(
                  "showAccept",
                  values.showAccept ||
                    !!(
                      value &&
                      get(
                        values,
                        `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`
                      )
                    )
                );
              }}
            />
          </div>

          <Input
            type="checkbox"
            label={
              "J’autorise Amellis Mutuelles à collecter et utiliser les données personnelles nécessaires à l’exécution de mon devis et une proposition adaptée à mes besoins."
            }
            subLabel={
              "Pour plus d’informations sur l’utilisation de vos données ainsi que sur la mise en œuvre par Amellis Mutuelles du dispositif sur la Réglementation Générale sur la Protection des Données (RGPD) qui est entré en vigueur le 25 Mai 2018, vous pouvez consulter notre politique de protection des données sur le site internet"
            }
            checked={get(values, "acceptContact") || false}
            {...bindInputProps({
              name: "acceptContact",
              values,
              ...formProps,
            })}
          />
        </div>
      </div>
      <div className="amellis__help--modal--actions">
        <Button type={"primary-light"} onClick={onClose} size={"large"}>
           Fermer
        </Button>
        <div className="flex--grow-1">
          <Button
            block
            type={"primary"}
            alignment={"center"}
            disabled={
              !get(values, "user.firstname") || !isEmpty(formProps.errors)
            }
            onClick={handleSubmit}
          >
            Continuer
          </Button>
        </div>
      </div>
    </div>
  );
}

export default View;
